function removeUndefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(Object.entries(obj).filter((_, v) => v !== undefined )) as Partial<T>
}

export function merge<T extends object>(target: T, ...sources: Partial<T>[]): T {
  let copy = { ...target }
  for (const source of sources) {
    const s = removeUndefined(source)
    copy = { ...copy, ...s }
  }
  return copy
}

export function maxlen(str: string, max: number) {
  return str.length > max ? str.substring(0, max - 1) : str
}

export function getTimezone() {
  return Math.round(-1 * (new Date().getTimezoneOffset() / 60))
}

export function getDomain(host: string): string {
  const parts = host.split('.');
  if (parts.length > 0 && (parts[0].includes('-dev') || parts[0].includes('-pre'))) {
    return parts[0];
  }
  return parts.length >= 2 ? parts[parts.length - 2] : '';
}
